const mastery = [
  {
    path: '/mastery',
    name: 'mastery',
    meta: { title: '四川省专精特新中小企业评估测试', node: 'mastery', reviewType: 6 },
    component: () => import('../views/mastery/index.vue')
  },
  {
    path: '/mastery_evaluation',
    name: 'mastery_evaluation',
    meta: { title: '四川省专精特新中小企业评估测试', node: 'mastery', reviewType: 6, childNode: true },
    component: () => import('../views/mastery/evaluation.vue')
  },
  {
    path: '/mastery_result',
    name: 'mastery_result',
    meta: { title: '四川省专精特新中小企业评估测试', node: 'mastery', reviewType: 6 },
    component: () => import('../views/mastery/result.vue')
  }
]

export default mastery;